import React, {Component} from 'react';
import PropTypes from "prop-types";
import {withRouter} from 'react-router-dom';
import Modal from 'react-modal'

import moment from 'moment';
import NotificationSystem from 'react-notification-system';
import {BeatLoader} from 'react-spinners';
import {get,postWithHeaders,patch,putWithHeadersResponse} from "../../../../server/actions";
import ReactTable from 'react-table';
import {_addNotification, _addNotificationError, convertTwoDecimalPoint, showFile, 
    getSchoolGrades, groupBy, getNotWorkingDays,getSessionStartEndDates} from '../../../../server/util';
import '../../../../../src/assets/css/react-table.css';
import PaymentModal from './paymentModal';

import _ from 'lodash';
import { date_format } from '../../../../server/constants';
var converter = require('number-to-words');

const modalStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        width: '60%',
        transform: 'translate(-50%, -50%)',
        overflow: 'initial',
        WebkitBoxShadow: '0 5px 11px 0 rgba(0,0,0,0.18), 0 4px 15px 0 rgba(0,0,0,0.15)',
        boxShadow: '0 5px 11px 0 rgba(0,0,0,0.18), 0 4px 15px 0 rgba(0,0,0,0.15)'
    }
};

class Enrollments extends Component {
    constructor(props){
        super(props);
        this.state={
            loading: false,
            applications:[],
            respData:[],
            columns:[],
            selectedButton:'all',
            payModalObject:{
                trxRecId:0,
                payModalIsOpen:false,
                paymentList:[],
                paymentType:'Cash',
                checkNumb:'',
                totalAmount:0.00
            }
        }
       
        this.getColumns = this.getColumns.bind(this);
        this.searchEnrollements = this.searchEnrollements.bind(this);
    }
    componentWillMount=()=>{
        this.setState({columns:this.getColumns()});
    }
    componentDidMount=()=>{
        this._notificationSystem = this.refs.notificationSystem;
        this.getData()
    }
    getData=()=>{
        this.setState({loading: true})
        const schoolID = sessionStorage.getItem("SchoolId")
        const schoolYearValue = sessionStorage.getItem("schoolYearValue")
        // const startDate = moment().startOf("isoWeek").format("YYYY-MM-DD")
        // const endDate = moment().startOf('isoWeek').add('days',4).format("YYYY-MM-DD")
        const getStartEndDates = getSessionStartEndDates(schoolYearValue) 
        const startDate = moment(getStartEndDates.startDate).format("YYYY-MM-DD")
        const endDate = moment(getStartEndDates.endDate).format("YYYY-MM-DD")
        console.log(startDate,endDate)
        get(`/${schoolID}/enrollments?startDate=${startDate}&endDate=${endDate}&isSummary=false&access_token=`).then((response)=>{
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response.json()
            }).then(data=>{
                
                this.setState({applications:data.response,loading: false,respData:data.response})
               
            }).catch(err=>{
                console.log(err)
                this.setState({loading: false})
            })
    }
    getColumns=()=>{
        let columns = [];
            columns.push({
                Header: 'Name',
                style: { textAlign: 'center' },
                accessor : "name"
            });
            columns.push({
                Header: 'Type',
                style: { textAlign: 'center' },
                accessor : "type"
            });
            columns.push({
                Header: 'Enrolled On',
                style: { textAlign: 'center' },
                accessor : "enrolledOn"
            });
            columns.push({
                Header: 'Start Date',
                style: { textAlign: 'center' },
                accessor : "startDate"
            });
            columns.push({
                Header: 'End Date',
                style: { textAlign: 'center' },
                accessor : "endDate"
            });
            columns.push({
                Header: 'Payment',
                style: { textAlign: 'center' },
                accessor : "payment"
            });
            columns.push({
                Header: 'Payment Type',
                style: { textAlign: 'center' },
                accessor : "paymentType"
            });
            columns.push({
                Header: 'Amount',
                style: { textAlign: 'center' },
                accessor : "amount"
            });
            columns.push({
                Header: 'Action',
                style: { textAlign: 'center' },
                Cell : row=>(
                    row.original.payment === "Pending" ?
                    <button type="button"
                        className="btn btn-xs bg-color-2"
                        style={{margin:0}}
                        onClick={(e)=>{
                            const rec=row.original;
                            this.openPaymentModal(rec);
                        }} 
                    >Pay
                    </button>
                    :
                    null
                    )
            });
            
            return columns;
        }
    nextPath(path) {
        this.props.history.push(path);
      }
    searchEnrollements(e){
        const searchStr = e.target.value
        let filterData = JSON.parse(JSON.stringify(this.state.respData))
        if(searchStr){
            filterData = filterData.filter((item)=> item.name.toLowerCase().includes(searchStr.toLowerCase())
            )
        }
        console.log(filterData)
        this.setState({applications:filterData})
      }
      handleButtonClick(type){
        let filterData = JSON.parse(JSON.stringify(this.state.respData))
        switch (type) {
            case "bc":
                filterData = filterData.filter(item=> item.type === "Before Care")
                break;
        
            case "ac":
                filterData = filterData.filter(item=> item.type === "After Care")
                break;
        
            case "paymentDue":
                filterData = filterData.filter(item=> item.payment === "Pending")
                break;
        
            default:
                break;
        }
    
        
        this.setState({selectedButton : type,applications:filterData})
         

      } 
      closePaymentModel=()=>{
        let _payModalObject=this.state.payModalObject
        _payModalObject.payModalIsOpen=false
        _payModalObject.trxRecId=0
        _payModalObject.paymentList=[];
        _payModalObject.paymentType='Cash';
        _payModalObject.checkNumb='';
        _payModalObject.totalAmount=0.00;
        this.setState({payModalObject:_payModalObject})
    }
   
    openPaymentModal=(res)=>{
         this.setState({loading: true});
        const url=`/reports/pkgTrxInfo/${res.trxRecId}?access_token=`;
        get(url)
        .then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
        }).then(data => {
            let totAmt=0.00
            const list=((data||{}).response||[]).map((item=>{
                totAmt=totAmt+parseFloat(convertTwoDecimalPoint(item.pkgCost,2))
                return {...item, fullName:item.stdLName+', '+item.stdFName}
            }));
            const _payModalObject=this.state.payModalObject||{};
            _payModalObject.trxRecId=res.trxRecId;
            _payModalObject.paymentList=list;
            _payModalObject.payModalIsOpen=true
            _payModalObject.totalAmount=totAmt;
            this.setState({ payModalObject:_payModalObject, loading: false })
        })
        .catch(
            (error) => {
                console.log('Get orderlist response', error)
                const _payModalObject=this.state.payModalObject||{};
                _payModalObject.paymentList=[];
                this.setState({ payModalObject:_payModalObject, loading: false})            }
        )
    }
    onPaymentSubmit=()=>{
        this.setState({loading: true});
        let headers = {
            'Content-Type': 'application/json'
        };
        const res={
            "type": this.state.payModalObject.paymentType,
            "refId":this.state.payModalObject.checkNumb
        }
        const url=`/transactions/pkgDuePayment/${this.state.payModalObject.trxRecId}?access_token=`;
        putWithHeadersResponse(url, JSON.stringify(res), headers).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
        }).then(data=>{
            _addNotification(data.statusMessage, this);
            this.closePaymentModel();
            this.setState({loading: false},()=>{
                this.getData();
            });
        }).catch(
            (error) => {
                _addNotificationError(error.message, this);
                this.closePaymentModel();
            }
        );
    }
    render(){
       
        return(<div>
            <NotificationSystem ref="notificationSystem"/>
            <div className='sweet-loading' style={{position: 'fixed', top: '50%', left: '48%', zIndex: '1000   '}}>
                    <BeatLoader
                        size={20}
                        color={'#ea7066'}
                        loading={this.state.loading}
                    />
                </div>
            <div className="container">          
            <div className="row">
                <div className="col-md-6 col-sm-12 col-xs-12 sectionTitle">
                        <h2>
                           
                        </h2>
                        </div>
                       
            </div>
            <div className="row">
                <div className="col-md-12">
                    <div className="table-responsive">
                        <section className="clearfix">
                            <div className="tab-content">
                                <div className="media">
                                    <div className="panel panel-primary">
                                        <div className="panel-body">
                                                <div className="row">
                                               
                                                    <div className="col-md-2 sectionTitle">
                                                        <h2>
                                                            <span>Enrollments</span>
                                                        </h2>
                                                        </div>
                                                        <div className="col-md-3">
                                                        <input type="text" id="search"
                                                            className="search form-control"
                                                            style={{ marginTop: '14px' }}
                                                            name="search"
                                                            placeholder="Search.."
                                                            onChange={this.searchEnrollements}
                                                        />
                                                    </div>
                                                    <div id="selector" className=" col-md-5 btn-group"  style={{ marginTop: '14px', display:"flex", justifyContent:"flex-end" }}>
                                                        <button type="button"
                                                            className={`btn btn-xs btn-inactive-color ${this.state.selectedButton === "all" ? "active" : ''} `}
                                                            id="all"
                                                            name="all"
                                                            style={{
                                                                margin: 0,
                                                                marginLeft: 3,
                                                                fontSize: 12
                                                            }}
                                                            onClick={()=>this.handleButtonClick("all")}
                                                           
                                                        >All
                                                        </button>
                                                        <button type="button"
                                                            className={`btn btn-xs btn-inactive-color ${this.state.selectedButton === "bc" ? "active" : ''} `}
                                                            id="beforeCare"
                                                            name="beforeCare"
                                                            style={{
                                                                margin: 0,
                                                                marginLeft: 3,
                                                                fontSize: 12
                                                            }}
                                                            onClick={()=>this.handleButtonClick("bc")}
                                                        >Before Care
                                                        </button>
                                                        <button type="button"
                                                            className={`btn btn-xs btn-inactive-color ${this.state.selectedButton === "ac" ? "active" : ''} `}
                                                            id="afterCare"
                                                            name="afterCare"
                                                            style={{
                                                                margin: 0,
                                                                marginLeft: 3,
                                                                fontSize: 12
                                                            }}
                                                            onClick={()=>this.handleButtonClick("ac")}
                                                        >After Care
                                                        </button>
                                                        <button type="button"
                                                            className={`btn btn-xs btn-inactive-color ${this.state.selectedButton === "paymentDue" ? "active" : ''} `}
                                                            id="paymentDue"
                                                            name="paymentDue"
                                                            style={{
                                                                margin: 0,
                                                                marginLeft: 3,
                                                                fontSize: 12
                                                            }}
                                                            onClick={()=>this.handleButtonClick("paymentDue")}
                                                        >Payment due
                                                        </button>
                                                    </div>
                                                    <div className="col-md-2">
                                                        <button class="pull-right btn bg-color-4" onClick={() => this.nextPath('/schoolAdmin/enrollmentSummary') }
                                                            style={{ margin: '10px 0px 10px 0px', color: "white" }}><i class="fa fa-arrow-circle-left" aria-hidden="true"></i>
                                                            &nbsp; Back</button>
                                                    </div>
                                                </div>
                                        <ReactTable   
                                            data={this.state.applications}                                                                         
                                            columns={this.state.columns}
                                            className="-striped -highlight"
                                            minRows={1}
                                            pageSize ={this.state.applications.length}
                                            showPaginationBottom={false} 
                                        />

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>
        <Modal isOpen={this.state.payModalObject.payModalIsOpen} style={modalStyles}>
                    <PaymentModal {...this.props} 
                    payModalObject={this.state.payModalObject||{}} 
                    onChangePaymentObj={(obj)=>{
                        let _payModalObject=this.state.payModalObject
                        _payModalObject=obj;
                        this.setState({payModalObject:_payModalObject})
                    }}
                    closePaymentModel={()=>{
                        this.closePaymentModel();
                    }}
                    onSubmitPayment={(e)=>{
                        this.onPaymentSubmit();
                    }}
                    />                        
                </Modal>
        </div>)
    }
}
export default withRouter(Enrollments)



// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/BcAc/ManageBcAc/enrollments.jsx